import React from 'react';
import {Card, Typography, Avatar, CardActions, Grid} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CustomBtn from './CustomBtn';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import defaultPicture from '../assets/defaultMemberPicture.svg'

const useStyles = makeStyles((theme) => ({
  CardStyle:{
    display:'inline-block',
    flexDirection:'column',
    justifyContent:'space-around',
    maxWidth:290,
    height:353.39,
    width:290,
    margin: '1.5rem 1.5rem',
    borderRadius:'30px'
  },
picture:{
  width:props =>(props.default ?theme.spacing(12): theme.spacing(16)),
  height:props =>(props.default ?theme.spacing(12): theme.spacing(16)),
  marginBottom:'20px',
  marginTop:props =>(props.default ?'20px': '30px'),
  margin:'auto',
},
name:{
  fontFamily:['Nunito'].join(','),
  marginBottom:'1px',
  color:'#4F5052'
},
title:{
  fontFamily:['Nunito'].join(','),
  color:'#4F5052'
},
mail:{
  fontFamily:['Nunito'].join(','),
  marginBottom:'10px',
  fontSize:'12px',
  color:'#4F5052'
},
actions:{
  margin:'15px 20px 10px 20px',
},
defaultitle:{
  marginTop:'30px',
  fontFamily:['Nunito'].join(','),
  color:'#4F5052'
},
}));

const MemberCard = (props) =>{ 
  console.log(props.talent)
  const classes = useStyles(props);
  const matches = useMediaQuery('(max-width:347px)');
  if(props.default===true){
    return (
      <Card className={classes.CardStyle}>
        <Typography variant='body1' className={classes.defaultitle} align="center">
        Add New Member
        </Typography>
        <Avatar className={classes.picture} src={defaultPicture}/>
        <Grid container justify = "center" style={{marginBottom:'30px'}}>
        <CustomBtn  width={'50%'} fntSize={matches? '8px':'10px'} colorwhite={false} txt={'Add'}/>
        </Grid>
      </Card>
    );
  }
  else{
    return (
      
      <div>
      <Card className={classes.CardStyle}>
        <Avatar className={classes.picture} src={props.picture}/>
        <Typography variant='h6' className={classes.name} align="center">
        <strong>{props.talent.name}</strong>
        </Typography>
        <Typography variant='body1' className={classes.title} gutterBottom align="center">
        {props.talent.title}
        </Typography>
        <Typography variant='subtitle2' className={classes.mail} align='center'>
        <strong>{props.talent.mail}</strong>
        </Typography>
        <CardActions className={classes.actions}>
          <Grid container spacing={3}>
            <Grid item xs={6}>
              <CustomBtn  width={'100%'} fntSize={matches? '8px':'10px'} colorwhite={true} txt={'Schedule Meeting'}/>
            </Grid>
            <Grid item xs={6} className={classes.viewBtn}>
              <CustomBtn colorwhite={false} width={'100%'} fntSize={matches? '8px':'10px'} onClick={props.ModalShow} txt={'View'}/>
            </Grid>
          </Grid>
        </CardActions>
        
      </Card>
      </div>
    );
  }
}
export default MemberCard;
